import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import DoubleArrow from '@material-ui/icons/DoubleArrow'
import React, { FC } from 'react'
import { navigateTo, scopedTranslation } from 'src/helpers'

import { useStyles } from './RegisterButton.styles'

interface RegisterButtonProps {
  buttonKey: 'call-to-action-high' | 'call-to-action-low' | 'call-to-action-bottom'
  centered?: boolean
}

const { t } = scopedTranslation('component.account_container')

export const RegisterButton: FC<RegisterButtonProps> = ({ buttonKey, centered }) => {
  const classes = useStyles()

  return (
    <Box
      className={ `${buttonKey} ${classes.registerButton}` }
      display='flex'
      justifyContent={ centered ? 'center' : 'flex-start' }
    >
      <Button
        startIcon={ <DoubleArrow fontSize='large' /> }
        variant='contained'
        color='secondary' size='large'
        onClick={ () => navigateTo(`${window.location.origin}/?open_registration=true&${window.location.search}`) }
      >
        <Typography variant='h3' component='span' color='inherit'>
          { t('check_your_creditworthiness') }
        </Typography>
      </Button>
    </Box>
  )
}
